import { useNavigate } from "react-router-dom";
import { Calendar, ShoppingBag, LogIn, UserPlus } from "lucide-react";
import { SpectatorSponsorBanner } from "@/components/spectator-sponsor-banner";
import { PublicHeader } from "@/components/public-header";
import { SpectatorTabBar } from "@/components/spectator-tab-bar";
import type { ReactNode } from "react";

// 102: PublicLayout renders the chrome for routes that anonymous spectators
// can reach without signing in (currently `/discover`, `/login`, `/register`,
// and `/shop`). It is parallel to `MinimalLayout` (authenticated, no roles)
// and `Layout` (authenticated, with roles), and lives OUTSIDE `RequireAuth`.
//
// Top-bar buttons mirror SuperSport Schools' anonymous header pattern:
// brand link home, primary nav (Events, Shop), then auth CTAs (Sign in,
// Register). No sidebar -- anonymous users have no per-account surfaces.
export function PublicLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background" data-component="public-layout">
      <PublicHeader
        navItems={[
          { label: "Events", icon: Calendar, onClick: () => navigate("/discover"), dataAction: "nav-events" },
          { label: "Shop", icon: ShoppingBag, onClick: () => navigate("/shop"), dataAction: "nav-shop" },
        ]}
        actions={[
          { label: "Sign in", icon: LogIn, variant: "outline", onClick: () => navigate("/login"), dataAction: "nav-sign-in" },
          { label: "Register", icon: UserPlus, variant: "default", onClick: () => navigate("/register"), dataAction: "nav-register" },
        ]}
      />
      {/* 102: SpectatorSponsorBanner mirrors MinimalLayout -- anonymous
          spectators are still spectators; sponsors paid for impressions and
          should see them whether the viewer is signed in or not. The
          /me/sponsor-ads endpoint serves the global fallback set anonymously. */}
      <SpectatorSponsorBanner />
      {/* 202: reserve space for the fixed spectator tab bar below md. */}
      <main className="p-4 pb-24 md:p-6 md:pb-6">{children}</main>
      <SpectatorTabBar />
    </div>
  );
}
